module.exports = __webpack_public_path__ + "media/images/Bullet-df1494e649e2a0d2d6bfde33ba5bd6e2.svg";